<template>
    <tr v-if='edit'>
        <td>
            <input type='text'  class="form-control" v-model='value.name'>
        </td>
        <td>
            <select class="form-control" v-model='value.min_book_ahead'>
                <option value='15'>15 minutes</option>
                <option value='30'>30 minutes</option>
                <option value='60'>60 minutes</option>
            </select>
        </td>
        <td>
            <select class="form-control" v-model='value.max_book_ahead'>
                <option value='1'>1 days</option>
                <option value='2'>2 days</option>
                <option value='3'>3 days</option>
                <option value='4'>4 days</option>
                <option value='5'>5 days</option>
                <option value='6'>6 days</option>
                <option value='7'>7 days</option>
                <option value='8'>8 days</option>
                <option value='9'>9 days</option>
                <option value='10'>10 days</option>
                <option value='11'>11 days</option>
                <option value='12'>12 days</option>
                <option value='13'>13 days</option>
                <option value='14'>14 days</option>
            </select>
        </td>
        <td>
            <input type='number' 
                min="0" max="720" size='8' step='1' 
                class="form-control" style='width: auto' v-model='value.interval_between_appointments'>
            <!-- <select class="form-control" v-model='value.interval_between_appointments'>
                <option value='5'>5 minutes</option>
                <option value='10'>10 minutes</option>
                <option value='15'>15 minutes</option>
                <option value='20'>20 minutes</option>
            </select> -->
        </td>
        <td><button v-on:click.prevent='$emit("remove")' class="btn btn-round btn-block btn-danger">{{ $t('translations.remove')}}</button></td>
    </tr>
    <tr v-else>
        <td>
            {{value.name}}
        </td>
        <td>
            {{value.min_book_ahead}} minutes
        </td>
        <td>
            {{value.max_book_ahead}} days
        </td>
        <td>
            {{value.interval_between_appointments}} minutes
        </td>
    </tr>
</template>

<script>

export default {
    name: 'appointment-session-type',
    props: {
        value: {

        },
        edit: {
            default: false
        }
    },
    data() {
        return {
            
        };
    },
    computed: {

    },
    watch: {

    },
    methods: {
    },
};
</script>